import { useSearchParams } from "react-router-dom"

import useLaunchDraft from "./useLaunchDraft"
import { AppError } from "../../../../errors/errorProcessors"
import { ILaunchDraftMapped } from "../../types/draftApplication/launchDraftTypes"

interface IDraftLoaderResult {
    isDraftMode: boolean
    draftData: ILaunchDraftMapped | undefined
    isLoading: boolean
    error: AppError | null
    draftId: string | null
}

/**
 * Hook that detects if a draft ID is present in the URL query parameters
 * and loads the draft data if needed.
 *
 * Usage: Add ?draftId=123 to the URL to load a draft
 */
export const useDraftLoader = (): IDraftLoaderResult => {
    const [searchParams] = useSearchParams()
    const draftId = searchParams.get("draftId")
    const isDraftMode = !!draftId
    const { data, isLoading, error } = useLaunchDraft(draftId || "")

    return {
        isDraftMode,
        draftData: isDraftMode ? data : undefined,
        isLoading: isDraftMode ? isLoading : false,
        error: isDraftMode ? error : null,
        draftId,
    }
}
